import React, { useEffect, useState } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { SpeedDial } from 'primereact/speeddial';
import { RadioButton } from "primereact/radiobutton";
import { InputText } from 'primereact/inputtext';
import InputTextCNPJ from "../../../Componentes/InputTextCNPJ"; // Verifique se o caminho está correto
import InputTextCPF from "../../../Componentes/InputTextCPF";
import InputCEP from "../../../Componentes/InputTextCEP";
import InputTextTelefone from "../../../Componentes/InputTextTelefone";
import InputTextEmail from "../../../Componentes/InputTextEmail";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import Conexao from "../../../providers/Conexao";
import md5 from "md5";
export default function ModalNovaRevenda(props) {
    const [visible, setVisible] = useState(false);
    const [errors, setErrors] = useState(false);
    const toast = React.useRef(null); // Ref para o Toast
    const [razaoSocial, setRazaoSocial] = useState('');
    const [nomeFantasia, setNomeFantasia] = useState('');
    const [cnpj, setCnpj] = useState('');
    const [inscEstadual, setInscEstadual] = useState('');
    const [endereco, setEndereco] = useState('');
    const [numero, setNumero] = useState('');
    const [cep, setCep] = useState('');
    const [complemento, setComplemento] = useState('');
    const [bairro, setBairro] = useState('');
    const [cidade,setCidade] = useState('');
    const [estado, setEstado] = useState('');
    const [telefoneComercial, setTelefoneComercial] = useState('')
    const [telefoneCelular, setTelefoneCelular] = useState('')
    const [email, setEmail] = useState('')
    const [senha, setSenha] = useState('')
    const [confirmacaoSenha, setConfirmacaoSenha] = useState('')

    const handleChange = () =>{

    }

    useEffect(()=>{
        setErrors(false)
    }, [visible])




    const insertEmpresa = () =>{

        setErrors(false)

        if(cnpj === ''){
            setErrors(true);
        }

        if(razaoSocial === ''){

            setErrors(true);

        }

        if(cidade === ''){

            setErrors(true);

        }

        if(estado === ''){

            setErrors(true);

        }

        if(email === ''){

            setErrors(true);

        }

        if(senha === ''){

            setErrors(true);

        }else if(senha !== confirmacaoSenha){

            setErrors(true)

        }

        if(errors){

            props.showMessage('danger',  'Preencha todos os campos obrigatórios');
            return

        }

        

    
        Conexao.post('empresasController/insertRevenda', {
            razaoSocial : razaoSocial,
            nomeFantasia : nomeFantasia,
            cnpj : cnpj,
            inscEstadual : inscEstadual,
            endereco : endereco, 
            numero : numero,
            cep : cep,
            complemento : complemento,
            bairro : bairro,
            cidade : cidade,
            estado : estado,
            telefoneComercial  :telefoneComercial ,
            telefoneCelular : telefoneCelular,
            email : email,
            senha : md5(senha),

        }).then(response =>{
            if(response.status == 200 && response.data.status === 'OK'){
                if(props.setRevenda){
                    
                    props.showMessage('success', 'Registro inserido com sucesso!')
                    setVisible(false)
                }else{
                    props.showMessage('warn', 'Não foi possível inserir')
                    setVisible(false)
                }
            }
        }).catch(error => {
            props.showMessage('danger', 'Não foi possível inserir')
            setVisible(false)
        })
    }


    const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };

      


      return (
            <div >
              
               

                 <Button 
                    onClick={() => {              
                        setVisible(true)
                    }}
  
                    icon="pi pi-plus" 
                    className= "p-button-primary p-button-sm" 
                    tooltip="Inserir um novo cliente" tooltipOptions={{ position: 'bottom' }}
                /> 
               
                
                <Dialog
                    header="Cadastro de Nova Revenda"
                    visible={visible}
                    maximizable
                    blockScroll={false} 
                    style={{ width: '60vw', }} // Largura padrão
                    breakpoints={{ '960px': '75vw', '720px': '90vw' }} // Ajuste para telas menores
                    onHide={() => setVisible(false)}
                >
                    {/* Opção de Pessoa Jurídica ou Física */}
                    
                    <div className="grid mt-2"  style={{padding : '20px', paddingTop : '0px'}}>
                         <div className="col-12 md:col-3">
                            <label htmlFor="documento" style={{fontWeight : 'bold'}}>CNPJ*</label>
                               <InputTextCNPJ
                                            value = {cnpj}
                                            onChange={(e)=>setCnpj(e.target.value)}
                                            name="cpf_cnpj"
                                            className="w-full mt-2"
        
                                        />
                                 {errors && cnpj === '' ? <small className="p-error">Informe o CNPJ</small> : null}
                            </div>
                        
                        <div className="col-12 md:col-7">
                            <label htmlFor="razaoSocial" style={{fontWeight : 'bold'}}>Razão Social*</label>
                       
                            <InputText
                                value={razaoSocial}
                                onChange={(e)=>setRazaoSocial(e.target.value)}
                                name="razaosocial"
                                className="w-full mt-2"
                            />
                                <small className="p-error">{errors.razaosocial}</small>
                                {errors && razaoSocial === '' ? <small className="p-error">Informe a Razão Social</small> : null}
                        </div>

                        <div className="col-12 md:col-2">
                            <label htmlFor="razaoSocial" style={{fontWeight : 'bold'}}>CEP*</label>
                            <>
                            <InputCEP
                                value={cep}
                                onChange={(e)=>setCep(e.target.value)}
                                name="cep"
                                setDataCep = {(data)=>{
                                    //  console.log(data)
                                    if(data){
                                        setEndereco(data.logradouro)
                                        setBairro(data.bairro)
                                        setComplemento(data.complemento)
                                        setCidade(data.localidade)
                                        setEstado(data.uf)
                                       
                                    }else{
                                        setEndereco('')
                                        setBairro('')
                                        setComplemento('')
                                        setCidade('')
                                        setEstado('')
                                    }
                                      
                                  }}
                                className="w-full mt-2"
                            />
                                <small className="p-error">{errors.cep}</small>
                                </>
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="razaoSocial">Logradouro</label>
                            <InputText
                                value={endereco}
                                onChange={(e)=>setEndereco(e.target.value)}
                                name="logradouro"
                                className="w-full mt-2"
                            />
                            
                        </div>
                        <div className="col-12 md:col-1">
                            <label htmlFor="razaoSocial">Nº</label>
                            <InputText
                                value={numero}
                                onChange={(e)=>setNumero(e.target.value)}
                                name="numero"
                                className="w-full mt-2"
                            />
                            
                        </div>

                        <div className="col-12 md:col-5">
                            <label htmlFor="complemento">Complemento</label>
                            <InputText
                                value={complemento}
                                onChange={(e)=>setComplemento(e.target.value)}
                                name="complemento"
                                className="w-full mt-2"
                            />
                            
                        </div>
                        <div className="col-12 md:col-3">
                            <label htmlFor="bairro">Bairro</label>
                            <InputText
                                value={bairro}
                                onChange={(e)=>setBairro(e.target.value)}
                                name="bairro"
                                className="w-full mt-2"
                            />
                            
                        </div>
                        <div className="col-12 md:col-5">
                            <label htmlFor="cidade" style={{fontWeight : 'bold'}}>Cidade *</label>
                            <InputText
                                value={cidade}
                                onChange={(e)=>setCidade(e.target.value)}
                                name="cidade"
                                className="w-full mt-2"
                            />
                            {errors && cidade === '' ? <small className="p-error">Informe a Cidade</small> : null}
                            
                        </div>
                        <div className="col-12 md:col-1">
                            <label htmlFor="Estado" style={{fontWeight : 'bold'}}>Estado *</label>
                            <InputText
                                value={estado}
                                onChange={(e)=>setEstado(e.target.value)}
                                name="estado"
                                className="w-full mt-2"
                                
                            />
                            {errors && estado === '' ? <small className="p-error">Informe o Estado</small> : null}
                        </div>

                         <div className="col-12 md:col-3">
                                <label htmlFor="telefoneCelular">Telefone Celular</label>
                                <InputTextTelefone
                                    value={telefoneCelular}
                                    onChange={(e)=>setTelefoneCelular(e.target.value)}
                                    name="telefoneCelular"
                                    className="w-full mt-2"
                                />
                            </div>
        
                            {/* Telefone Comercial */}
                            <div className="col-12 md:col-3">
                                <label htmlFor="telefoneComercial">Telefone Comercial</label>
                                <InputTextTelefone
                                    value={telefoneComercial}
                                    onChange={(e)=>setTelefoneComercial(e.target.value)}
                                    name="telefoneComercial"
                                    className="w-full mt-2"
                                />
                            </div>
        
                            {/* E-mail */}
                            <div className="col-12 md:col-9">
                                <label htmlFor="email" style={{fontWeight : 'bold'}}>E-mail*</label>
                                <>
                                <InputTextEmail
                                    value={email}
                                    onChange={(e)=>setEmail(e.target.value)}
                                    name="email"
                                    className="w-full mt-2"
                                />
                                    {errors && email === '' ? <small className="p-error">Informe o Email</small> : null}
                                    </>
                            </div>

                            <div className="col-12 md:col-4">
                                <label htmlFor="email" style={{fontWeight : 'bold'}}>Senha*</label>
                                <>
                                <InputText
                                    value={senha}
                                    onChange={(e)=>setSenha(e.target.value)}
                                    name="email"
                                    type="password"
                                    className="w-full mt-2"
                                />
                                    {errors && senha === '' ? <small className="p-error">Informe a Senha</small> : null}
                                    </>
                            </div>

                            <div className="col-12 md:col-4">
                                <label htmlFor="email" >Confirmação</label>
                                <>
                                <InputText
                                    value={confirmacaoSenha}
                                    onChange={(e)=>setConfirmacaoSenha(e.target.value)}
                                    name="confirmacaoSenha"
                                    type="password"
                                    className="w-full mt-2"
                                />
                                    {errors && senha !== confirmacaoSenha ? <small className="p-error">Senha e Confirmação de senha não são iguais</small> : null}
                                    </>
                            </div>

                    </div>
                     <div className="mt-4 flex justify-content-end mt-2">
                            <Button disabled={props.loading} severity="secondary" className="mt-2 mr-2" label="Cancelar" icon="pi pi-times" onClick={() => {
                                    confirmDialog({
                                    message: 'Deseja cancelar?',
                                    header: 'Confirmação',
                                    icon: 'pi pi-exclamation-triangle',
                                    acceptLabel: 'Sim',
                                    rejectLabel: 'Não',
                                    accept: () => {setVisible(false)}
                                });
                            }} />
                            <Button disabled={props.loading} severity="primary" className="mt-2 mr-2" label="Salvar" icon="pi pi-save" onClick={() => {
                                   
                                    confirmDialog({
                                    message: 'Confirma a inclusão desse novo Cliente?',
                                    header: 'Confirmação',
                                    icon: 'pi pi-exclamation-triangle',
                                    acceptLabel: 'Sim',
                                    rejectLabel: 'Não',
                                    accept: () => {
                                        insertEmpresa()
                                    } 
                                });
                            }} />
                        </div>
                </Dialog>
                <Toast ref={toast} />
            </div>
      )
    }